import React, {useContext, useRef, useState, useEffect} from 'react';
import {Container} from "react-bootstrap";
import PageHeader from "components/PageHeader";
import AgGridToolbar from "components/AgGridToolbar/AgGridToolbar";
import {AgGridReact} from "ag-grid-react";
import {
    DEFAULT_GRID_PAGINATION_SIZE,
    ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE,
    GRID_COLUMN_PROPERTY
} from "utils/Constants";
import {
    dateToString,
    stringToDate
} from "utils/FormatUtils";
import useWindowDimensions from "hooks/Dimensions";
import {WireTemplatesContext} from "./context";
import * as URL from "service/UrlConstant";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import ActionModifyRenderer from "components/ActionModifyRenderer";
import {createExcelExportParams} from "utils/ExcelExportUtils";
import {ActionPanelContext} from "context/action";
import {UtilsContext} from "context/utils";
import {EntityAccountsContext} from "../../../components/entity-accounts/context";
import {addPropertiesToGridColumns, getDisplayedNumberOfGridRows} from "../../../utils/gridColumnUtils";
import ScrollButton from "../../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
import AddNewWireTemplateStep1 from "./AddNewWireTemplateStep1";
import * as Routes from "../../../routes/Routes";
import {useHistory} from "react-router-dom";

export default function WireTemplatesResultPanel() {
    const {wireTemplateResultsDisplayState,
        setWireTemplateResultsDisplayState, showGridToolbar,
        setAddWireTemplateState, wireTemplatePanelPageState,
        TEMPLATE_PANEL_SEARCH_PAGE, displayWireTemplatePanelPage,
        wireTemplatePanelFilterState, copyDateToAddWireTemplateState1,copyDateToAddWireTemplateState2,
        copyDateToAddWireTemplateState3,copyDateToAddWireTemplateState4,copyDateToAddWireTemplateState5,
        setViewWireTemplateApproveFunction, setViewWireTemplateRejectFunction,
        initAddWireTemplateState} = useContext(WireTemplatesContext)
    const {makeGetRequestNoParams, makePutRequest, makePostRequest} = useContext(SecurityContext);
    const {error} = useContext(ToastContext);
    const {setHandleApproveFunction, setHandleRejectFunction,
        setHandleExportFunction, setHandleRefreshFunction,setDefaultStatus,
        setHandleDeleteFunction, setIsValidApprover, isValidApprover, setIsValidRejecter, isValidRejecter} = useContext(ActionPanelContext)
    const {hiddenExportGridApi, showButton, setShowButton,paginationPageSize, setPaginationPageSize} = useContext(UtilsContext);
    const {entityAccountsNoSwap} = useContext(EntityAccountsContext);


    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [columnDefs, setColumnDefs] = useState([]);
    const [showAddTemplate, setShowAddTemplate] = useState(false);

    const {isDesktop, isMobile} = useWindowDimensions();
    let history = useHistory();
    function navigateToPage(path) {
        history.push(path);
    }

    const columnTypes ={
        actionColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            pinned:isDesktop?'':'right',
            width:isDesktop?250:100,
            autoHeight: true,
            wrapText: true,
        },
        flexColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            suppressMenu:true,
            flex:1,
            suppressMovable:true,
        },
        FlexHeightColType: {
            sortable: false,
            resizable: false,
            floatingFilter: false,
            filter: false,
            enableCellChangeFlash: false,
            lockPinned:!!isMobile,
            autoHeight: true,
            wrapText: true,
            minWidth:500
        }
    }

    const defaultColDef = {
        sortable:true,
        resizable:true,
        floatingFilter:true,
        filter:true,
        enableCellChangeFlash:true,
        lockPinned:!!isMobile,
    };

    useEffect(() => {
        setColumnDefs( setupActionColumns());
        setHandleExportFunction({handleExport:exportQueryList, gridApi: gridApi});
        setHandleApproveFunction({handleApprove:handleApproveActionClicked, gridApi: gridApi})
        setHandleRejectFunction({handleReject:handleRejectActionClicked, gridApi: gridApi})
        setHandleDeleteFunction({handleDelete:handleDeleteActionClicked, gridApi: gridApi})
        setHandleRefreshFunction({handleRefresh: handleRefreshActionClicked, gridApi:null });
        if(wireTemplatePanelPageState.currentPage === TEMPLATE_PANEL_SEARCH_PAGE && wireTemplateResultsDisplayState.resData){
            setRowData(wireTemplateResultsDisplayState.resData);
        }
        else {
            getWireTemplates()
        }

        console.log("mnyWiresResultsDisplayState", wireTemplateResultsDisplayState)
    }, [wireTemplatePanelPageState])


    useEffect(() => {
        setColumnDefs( setupActionColumns());
        setHandleExportFunction({handleExport:exportQueryList, gridApi: gridApi});
        setHandleApproveFunction({handleApprove:handleApproveActionClicked, gridApi: gridApi})
        setHandleRejectFunction({handleReject:handleRejectActionClicked, gridApi: gridApi})
        setHandleDeleteFunction({handleDelete:handleDeleteActionClicked, gridApi: gridApi})
        setHandleRefreshFunction({handleRefresh: handleRefreshActionClicked, gridApi:null });
        console.log("mnyWiresResultsDisplayState", wireTemplateResultsDisplayState)

    }, [wireTemplateResultsDisplayState])


    const handleActionIconClick = (params) => {
        setShowAddTemplate(true)
    }

    const setupActionColumns = () => {
        console.log("Calling setupActionColumns ")
        let updatedColumnDefs = [...columnDefsResultsPanel];
        updatedColumnDefs.splice(1, 1, {headerName: 'Action',
            field:'idTemplate',
            colId: 'idTemplate_action',width:135,
            type: 'actionColType',
            cellRenderer: "modifyRenderer",
            cellRendererParams: {
                clicked: (data) => handleActionIconClick(data),
            }
        });
        return updatedColumnDefs;
    }

    const handleRefresh = () => {

        const params = {
            managerId: entityAccountsNoSwap.managerId,
            accountId: entityAccountsNoSwap.accountId,
            status: wireTemplatePanelFilterState.status,
            dtStart: wireTemplatePanelFilterState.startDate ? dateToString(wireTemplatePanelFilterState.startDate) : null,
            dtEnd: wireTemplatePanelFilterState.endDate ? dateToString(wireTemplatePanelFilterState.endDate) : null
        }

        const onSuccessResponse = (response) => {
            const wireTemplateDisplayState = JSON.parse(JSON.stringify(wireTemplateResultsDisplayState))
            wireTemplateDisplayState.resData = ([...response.data])
            setWireTemplateResultsDisplayState(wireTemplateDisplayState);
            displayWireTemplatePanelPage(TEMPLATE_PANEL_SEARCH_PAGE);
        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error refreshing templates")
        }

        makePostRequest(params,
            URL.WIRE_TEMPLATE_SEARCH_URL , onSuccessResponse, onErrorResponse);
    }

    const getWireTemplates = () => {

        const onSuccessResponse = (response) => {
            const wireTemplateDisplayState = JSON.parse(JSON.stringify(wireTemplateResultsDisplayState))
            wireTemplateDisplayState.resData = ([...response.data])
            setWireTemplateResultsDisplayState(wireTemplateDisplayState);
            setRowData([...response.data])
            console.log("response.data", response.data)
        }

        const onErrorResponse = (err) => {
            console.error(err);
            error("Error getting templates")
        }

        makeGetRequestNoParams(URL.WIRE_TEMPLATE_SEARCH_PEND_URL , onSuccessResponse, onErrorResponse);
    };

    const handleApproveActionClicked = (comment, data, onSuccess, onError ) => {

        const params = []

        data.forEach(data => {
            params.push({"id": data.id, "idTemplate": data.idTemplate, "comment": comment})
        })

        const onSuccessResponse = (response) => {
            console.log("response.data", response.data)
            if(onSuccess) onSuccess()
            handleRefresh()
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if(onError) onError(err);
        }

        makePutRequest(params, URL.WIRE_TEMPLATE_LIST_APPR_URL , onSuccessResponse, onErrorResponse);
    }

    const handleRejectActionClicked = (comment, data, onSuccess, onError ) => {

        const params = []

        data.forEach(data => {
            params.push({"id": data.id, "idTemplate": data.idTemplate, "comment": comment})
        })

        const onSuccessResponse = (response) => {
            console.log("response.data", response.data)
            if(onSuccess) onSuccess()
            handleRefresh()
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if(onError) onError(err);
        }

        makePutRequest(params, URL.WIRE_TEMPLATE_LIST_REJ_URL , onSuccessResponse, onErrorResponse);
    }

    const handleDeleteActionClicked = (gridApi, onSuccess, onError ) => {

        const params = []

        gridApi.getSelectedRows().forEach(data => {
            params.push({"id": data.id, "idTemplate": data.idTemplate})
        })

        const onSuccessResponse = (response) => {
            console.log("response.data", response.data)
            if(onSuccess) onSuccess()
            handleRefresh()
        }

        const onErrorResponse = (err) => {
            console.error(err);
            if(onError) onError(err);
        }

        makePutRequest(params, URL.WIRE_TEMPLATE_LIST_DEL_URL , onSuccessResponse, onErrorResponse);
    }

    const handleRefreshActionClicked = (refreshCriteria ,gridApi , onSuccess, onError) => {
        handleRefresh()
    };

    const exportQueryList = (type, rowData) => {
        const columnDef = columnDefsResultsPanel.filter(col => col.headerName !== 'Select')
        //Set Column definition
        hiddenExportGridApi.current.api.setColumnDefs(columnDef);
        //Set Data
        hiddenExportGridApi.current.api.setRowData(rowData || wireTemplateResultsDisplayState.resData);
        //Export as csv/excel
        type==='EXCEL' ?
            hiddenExportGridApi.current.api.exportDataAsExcel(createExcelExportParams('Template')) :
            hiddenExportGridApi.current.api.exportDataAsCsv()
    }

    const LogItem = function (params){
        return(<>
            {
                params.value.toString().split("\r\n").map( (log, index) => {
                    return (<React.Fragment key={`log-line-${index}`}>{log}<br /></React.Fragment>)
                })}
        </>);
    }

    const logRenderer = function (props){
        if(!props.data.comment)
            return (<></>)
        return <LogItem value = {props.data.comment}/>
    }
    const viewCellRenderer = function (props){
        return (<>
            {
                <a className="td-link" href="#" onClick={(e) => {
                    e.preventDefault();
                    onViewClicked(props.data);
                    navigateToPage(Routes.WIRE_TEMPLATE_NEW_STEP6 + "?from=viewClick" )
                }}>View</a>
            }
        </>);
    }
    const onViewClicked = (data) => {
        let addWireTemplateDisplayState = {...initAddWireTemplateState}

        copyDateToAddWireTemplateState1(data, addWireTemplateDisplayState)
        copyDateToAddWireTemplateState2(data,addWireTemplateDisplayState)
        copyDateToAddWireTemplateState3(data,addWireTemplateDisplayState)
        copyDateToAddWireTemplateState4(data,addWireTemplateDisplayState)
        copyDateToAddWireTemplateState5(data,addWireTemplateDisplayState)

        setViewWireTemplateApproveFunction(() => handleApproveActionClicked)
        setViewWireTemplateRejectFunction(() => handleRejectActionClicked)
        setAddWireTemplateState(addWireTemplateDisplayState)
    }

    const instructionsRenderer = function (props){
        if(!props.data.wireInstructions)
            return (<></>)
        return <LogItem value ={props.data.wireInstructions}/>
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    }

    const onDataRendered = (params) => {
        params.columnApi.autoSizeAllColumns();
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const onPaginationChanged = () => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    function pageTitle(){
        return "Templates "
    }

    const autoSizeStrategy = {
        type: 'fitCellContents'
    };

    const onSelectionChanged = (param) => {
        console.log("on selection",param)
    }

    const onRowSelected = (row) => {

        if(!row.node.selected || row.data.isValidApprover !== isValidApprover) {
            setIsValidApprover(true)

            gridApi.getSelectedRows()
                .filter(row => !row.isValidApprover)
                .map(row => {
                        setIsValidApprover(row.isValidApprover);
                    }
                );
        }

        if(!row.node.selected || row.data.isValidRejecter !== isValidRejecter){
            setIsValidRejecter(true)

            gridApi.getSelectedRows()
                .filter(row => !row.isValidRejecter)
                .map(row => {
                        setIsValidRejecter(row.isValidRejecter);
                    }
                );
        }

    }

    const isRowSelectable = (param) => {
        return param.data && param.data.isEditable;
    }

    const updatedColumnDefs = addPropertiesToGridColumns(columnDefsResultsPanel, GRID_COLUMN_PROPERTY)

    return(<>
        <Container fluid>
            <PageHeader text={pageTitle()}>
                {/*<WiresParamsBadge/>*/}
            </PageHeader>

            { showGridToolbar && <AgGridToolbar
                wireTemplateScreen={true}
                gridApi={gridApi}
                gridColumnApi={gridColumnApi}
                columnDefs={columnDefs}
                setColumnDefs={setColumnDefs}
                refreshCriteria={wireTemplateResultsDisplayState.templateSearch}
                rowData={rowData}
                paginationPageSize={paginationPageSize}
                setPaginationPageSize={setPaginationPageSize}
                showRejectButton={true}
            >
            </AgGridToolbar>}
            <div className="ag-theme-alpine">
                <AgGridReact
                    ref={gridRef}
                    domLayout={'autoHeight'}
                    frameworkComponents={{
                        logRenderer: logRenderer,
                        instructionsRenderer: instructionsRenderer,
                        viewCellRenderer:viewCellRenderer
                    }}
                    paginationPageSize={DEFAULT_GRID_PAGINATION_SIZE}
                    groupDefaultExpanded={'1'}
                    enableRowGroup={false}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    suppressModelUpdateAfterUpdateTransaction={true}
                    suppressScrollOnNewData={true}
                    suppressAggFuncInHeader={true}
                    allowShowChangeAfterFilter={false}
                    rowGroupPanelShow={'never'}
                    enableSorting={true}
                    enableFilter={true}
                    pagination={true}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onDataRendered}
                    onPaginationChanged={onPaginationChanged}
                    rowDataUpdated={onDataRendered}
                    defaultColDef={defaultColDef}
                    columnDefs={updatedColumnDefs}
                    columnTypes={columnTypes}
                    rowData={rowData}
                    animateRows={true}
                    rowSelection={'multiple'}
                    isRowSelectable={isRowSelectable}
                    autoSizeStrategy={autoSizeStrategy}
                    onRowSelected={onRowSelected}
                    selectionChanged={onSelectionChanged}
                    popupParent={document.body}
                >
                </AgGridReact>
            </div>
            {showButton && <ScrollButton showButton={showButton}/>}
        </Container>
    </>);
}

export const columnDefsResultsPanel = [
    {headerName: 'Select', checkboxSelection:true,suppressMovable:true, lockPosition:true, filter:false, maxWidth :100},
    {
        headerName: 'View',
        field: 'View',
        cellRenderer: 'viewCellRenderer'
    },
    {headerName: 'id', field: 'id',hide:true, colId: 'id', suppressColumnsToolPanel:true},
    {headerName: 'idTemplate', field: 'idTemplate',hide:true, colId: 'idTemplate', suppressColumnsToolPanel:true},
    {headerName: 'idAccount', field: 'idAccount',hide:true, suppressColumnsToolPanel:true},
    {headerName: 'idManager', field: 'idManager',hide:true, suppressColumnsToolPanel:true},
    {headerName: 'currencyUSDSwitch', field: 'currencyUSDSwitch',hide:true, suppressColumnsToolPanel:true},
    {headerName: 'Status', field: 'status'},
    {headerName: 'Template Name', field: 'templateName'},
    {headerName: 'Client', field: 'cdClient'},
    {headerName: 'Entity', field: 'managerNameShort'},
    {headerName: 'Effective', field: 'dtEffective', valueGetter: (params)=>stringToDate(dateToString(params.data.dtEffective))},
    {headerName: 'BIC/SWIFT', field: 'senderBIC'},
    {headerName: 'Others', field: 'remittanceInformation', maxWidth :250 ,  tooltipValueGetter: params => params.data.remittanceInformation},
    {headerName: 'Settlement Currency', field: 'settlementCurrency'},
    {headerName: 'Sender to Receiver Info', field: 'purposeCode'},
    {headerName: 'Charge Details', field: 'chargesBearer'},
    {headerName: 'Linked To Wire', field: 'linkedToWire'},
    {headerName: 'Comment', field: 'comment', type: 'FlexHeightColType',cellRenderer: 'logRenderer',  maxWidth :300 ,  tooltipValueGetter: params => params.data.comment},
    {headerName: '', field: '', type: 'flexColType', suppressColumnsToolPanel: true},
];

